import React from 'react';
import PropTypes from 'prop-types';
import DropDownButton from '../DropDownButton';
import SendPaymentSlip from './SendPaymentSlip';
import translate from 'components/hoc/translate';
import DownloadPDF from 'components/button/DownloadPDF';
import { downloadBookingPaymentSlipRequest } from 'http/requests/bookings/bookingDownloadRequests';
import { downloadPaymentSlipFailure } from 'store/actions/payment-slip/paymentSlipActions';

const PaymentSlipActions = (props) => {
    const { id, orderId, translate } = props;

    const buttonStyle = { borderRadius: '0' };

    return (
        <DropDownButton title={ translate('resources.orders.paymentSlip.title') } >
            <SendPaymentSlip id={ id } style={ buttonStyle } />
            <DownloadPDF
                failureAction={ downloadPaymentSlipFailure }
                fileName={ `booking_${ orderId }_payment_slip.pdf` }
                id={ id }
                request={ downloadBookingPaymentSlipRequest }
                style={ buttonStyle }
                title={ translate('resources.orders.paymentSlip.download.title') }
            />
        </DropDownButton>
    );
};

PaymentSlipActions.propTypes = {
    id: PropTypes.number.isRequired,
    orderId: PropTypes.number.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(PaymentSlipActions);


// WEBPACK FOOTER //
// ./src/components/button/payment-slip/PaymentSlipActions.js